module.exports = __webpack_public_path__ + "static/partner-img3-d0a374c6c00e6163db28d060611c1bb6.png";